import React, { useState } from "react";
import axios from "axios";
import { toast } from 'sonner'
import { useUser } from '../../../../store/userState'
import generateTimestamp from "../../../../middlewares/GlobalUtils/generateTimeStamp";

import { Button, Dialog, DialogHeader, DialogBody, DialogFooter, Input, } from "@material-tailwind/react";
import { FcPlus } from "react-icons/fc";

export function PurchaseOrderModal({ onAlterState }) {
  const [open, setOpen] = useState(false)
  const [poNumber, setPoNumber] = useState('')
  const { user } = useUser()

  const handleOpen = () => setOpen(!open)

  const handleSetPOnumber = (event) =>{
    setPoNumber(event.target.value)
  }

  const handleGetPoData = () => {

    const batchData = {
      batchId: generateTimestamp(),
      poNumber: poNumber,
      addedBy: user.email
    }

    console.log(batchData)

    axios.post('/api/extensive-po-requests/generateBatch', batchData)
    .then(response => {
      if(response.data.message){
        toast.success(`${response.data.message}`)
        onAlterState()
        setPoNumber('')
        setOpen(!open)
      }
    })
    .catch(error =>{
      console.error('Error:', error)
      const errorMessage = error.response?.data?.message || 'An error occurred during add.'
      toast.error(errorMessage)
    })
  }

  return (
    <>

      <Button onClick={handleOpen} variant="gradient" color="purple">
        Submit
      </Button>
      <Dialog
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogHeader>Input PO Number</DialogHeader>
        <DialogBody className="flex justify-center">
          <div className="w-72">
            <Input label="PO number" icon={<FcPlus className="h-5 w-5"/>} value={poNumber} onChange={handleSetPOnumber}/>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="text"
            color="red"
            onClick={handleOpen}
            className="mr-1"
          >
            <span>Cancel</span>
          </Button>
          <Button variant="gradient" color="green" onClick={handleGetPoData}>
            <span>Confirm</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}